import {findContainer, getDataAttributes} from "./_util";

const VGMap = {
	isInit: false,
	pointCollection: null,
	controls: [
		'geolocationControl',
		'searchControl',
		'typeSelector',
		'fullscreenControl',
		'scrollZoom'
	],
	placeMark: {
		icon: {
			preset: 'islands#icon',
			iconColor: '#ff3819'
		},
		layout: '<div class="vg-map-marker color-main"><div class="pin bounce"></div><div class="pulse"></div></div>',
	},
	defaults: {
		controls: [],
		sizes: {
			width: '100%',
			height: '500px'
		},
		zoom: 15,
		mark: 'icon',
	},

	init: function (map, arg = {}) {
		if (!map) {
			VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
			return false;
		}

		let params = {},
			dataParams = {};

		if (typeof map === 'string') {
			params.map = findContainer('#' + map);
			params.id = map;
			if (params.map) dataParams = getDataAttributes(params.map);
		} else if (typeof map === 'object') {
			let target = map.getAttribute('id') || null;

			if (!target) {
				VGLog("error", ["Мон Синьор! Путь к карте не найден"]);
				return false;
			}

			params.id   = target;
			params.map  = findContainer('#' + target);
			dataParams  = getDataAttributes(map, true);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.map) {
			VGLog("error", ["Сударь! А где, собственно, карта?"]);
			return false;
		}

		params = Object.assign({}, dataParams, params, arg, VGMap.defaults);

		delete params['vg-map'];

		VGMap.isInit = true;
		VGMap.run(params);
	},

	run: function (params) {
		if (!VGMap.isInit) return false;

		VGMap.setMapSize(params);

		// получаем координаты
		if ('points' in params) {
			params.points = JSON.parse(params.points);
			if (params.points.length && !(params.lat && params.lon)) {
				for (let i = 1; i <= params.points.length; i++) {
					if (('lat' in params.points[i - 1]) && ('lon' in params.points[i - 1])) {
						if (i === 1) {
							params.lat = params.points[i - 1].lat;
							params.lon = params.points[i - 1].lon;
						}
					}
				}
			}
		}

		if (params.lat && params.lon) {
			ymaps.ready(init);

			function init() {
				/* Рисуем карту */
				let myMap = VGMap.setMap(params.id, [params.lat, params.lon], params.zoom);

				/* Отключаем не нужное. Передаем в массив (дата аттрибут), то что не нужно отключать, если нужно отключить всё оставляем пустым */
				VGMap.disabled(myMap, params.controls);

				if ('points' in params) {
					let objects = VGMap.setPlaceMark(myMap, params, true);
					VGMap.pointCollection = new ymaps.GeoObjectCollection();

					for (let i in objects) {
						VGMap.pointCollection.add(objects[i]);
					}

					myMap.geoObjects.add(VGMap.pointCollection);
					myMap.setBounds(myMap.geoObjects.getBounds(), {
						checkZoomRange: true,
						zoomMargin: 40
					});
				} else {
					VGMap.setPlaceMark(myMap, params);
				}

				if (window.innerWidth < 1000) {
					myMap.behaviors.get('drag').disable();
				}
			}
		} else {
			VGLog("error", ["Ахпер! Гдэ координаты!"]);
			return false;
		}
	},

	setMap: function (id, coordinates, zoom) {
		return new ymaps.Map(id, {
			center: coordinates,
			zoom: zoom,
			controls: ['smallMapDefaultSet'],
		}, {
			searchControlProvider: 'yandex#search',
			suppressMapOpenBlock: true,
		});
	},

	setMapSize: function (params) {
		// todo тут jquery
		let $map = $(params.map),
			$height = $map.height();

		if ($height !== 0) {
			params.sizes.height = $height;
		} else {
			if ('height' in params) {
				params.sizes.height = parseInt(params["height"]);
				$map.css('height', params.sizes.height);
			} else {
				let hParent = $map.parent().height();
				if (hParent === 0) {
					hParent = $map.parent().parent().height();
					$map.css('height', hParent);
				}
			}
		}

		if ('width' in params) {
			params.sizes.width = parseInt(params["width"]);
			$map.css('width', params.sizes.width);
		}

		return false;
	},

	disabled: function (map, items = []) {
		// todo тут jquery
		if (items.length > 0) {
			$.each(items, function (i, val) {
				if (VGMap.controls.indexOf(val) > -1) {
					delete VGMap.controls[i];
				}
			});
		}

		$.each(VGMap.controls, function (i, val) {
			if (val !== 'undefined') {
				map.controls.remove(val);
			}
		});
	},

	setPlaceMark: function (map, params, isPoints = false) {
		let marker;

		if (params.mark === 'layout') {
			// todo дописать
			let circleLayout = ymaps.templateLayoutFactory.createClass(VGMap.placeMark.layout);

			marker = {
				iconLayout: circleLayout
			}
		} else if (params.mark === 'icon') {
			let color = '';

			if ('color' in params) {
				color = params.color;
			} else {
				color = VGMap.placeMark.icon.iconColor;
			}

			marker = {
				preset: VGMap.placeMark.preset,
				iconColor: color
			}
		}

		if (isPoints) {
			let points = [];

			for (let i in params.points) {
				points[i] = new ymaps.Placemark([params.lat, params.lon], {}, marker);
			}

			return points;
		} else {
			let placeMark = new ymaps.Placemark(
				map.getCenter(), {}, marker
			);

			map.geoObjects.add(placeMark);

			return placeMark;
		}
	},
}

function onReady() {
	let $maps = document.querySelectorAll('[data-vg-map]');
	if ($maps.length) {
		for (let $map of $maps) {
			VGMap.init($map);
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGMap;